import { useSelector, useDispatch } from 'react-redux';
import { CartoLayer, colorBins } from '@deck.gl/carto';
import { selectSourceById, updateLayer } from '@carto/react-redux';
import { useCartoLayerProps } from '@carto/react-api';
import htmlForFeature from 'utils/htmlForFeature';
import { useEffect } from 'react';

export const HISTORICAL_ALL_CRASH_LAYER_ID = 'historicalAllCrashLayer';

const layerConfig = {
  title: 'Historical All Crash Events',
};

function HistoricalAllCrashLayer() {
  const dispatch = useDispatch();
  const { historicalAllCrashLayer } = useSelector((state) => state.carto.layers);
  const source = useSelector((state) => selectSourceById(state, historicalAllCrashLayer?.source));
  const cartoLayerProps = useCartoLayerProps({ source });
  const viewState = useSelector((state) => state.carto.viewState);
  
  // Calculate H3 resolution based on zoom level
  // Table's H3 index has a max resolution, so we aggregate up from there
  const getH3ResolutionFromZoom = (zoom) => {
    if (zoom >= 11) return 7;
    if (zoom >= 9) return 6;
    if (zoom >= 7) return 5;
    return 4;
  };
  
  const h3Resolution = getH3ResolutionFromZoom(viewState.zoom);

  useEffect(() => {
    // Force layer update when zoom changes to recalculate polygon size
    console.log('Zoom level changed:', viewState.zoom);
    console.log('Updating layer with new H3 resolution:', h3Resolution);
  }, [viewState.zoom, dispatch, historicalAllCrashLayer, h3Resolution]);
  
  if (historicalAllCrashLayer && source) {
    return new CartoLayer({
      ...cartoLayerProps,
      id: HISTORICAL_ALL_CRASH_LAYER_ID,
      geoColumn: 'h3',
      aggregationExp: 'COUNT(REPORT_NUMBER) AS Count_Of_All_Crashes',
      aggregationResLevel: h3Resolution,
      stroked: false,
      pointRadiusUnits: 'pixels',
      lineWidthUnits: 'pixels',
      pickable: true,
      visible: historicalAllCrashLayer.visible,
      opacity: historicalAllCrashLayer.opacity,
      extruded: false, // Ensure polygons are 2D
      polygonOffset: [1, 1], // Small padding between polygons

      getFillColor: colorBins({
        attr: 'Count_Of_All_Crashes',
        domain: [1, 301, 601, 1000],
        colors: [
          [251, 230, 197, 0], // 0 (transparent)
          [251, 230, 197],    // 1-300, #FBE6C5
          [245, 186, 152],    // 301-600, #F5BA98
          [220, 113, 118],    // 601-1000, #DC7176
          [156, 63, 93],      // 1000+, #9C3F5D
        ],
      }),


      onDataLoad: (data) => {
        dispatch(
          updateLayer({
            id: HISTORICAL_ALL_CRASH_LAYER_ID,
            layerAttributes: { ...layerConfig },
          })
        );
        cartoLayerProps.onDataLoad && cartoLayerProps.onDataLoad(data);
      },

      onHover: (info) => {
        if (info?.object) {
          info.object = {
            html: htmlForFeature({
              feature: info.object,
            }),
          };
        }
      },
    });
  }
}

export default HistoricalAllCrashLayer;
